<template>
  <!-- <v-simple-table>
        <template v-slot:default>
        <thead>
            <tr>
                <th class="text-left">Заголовок</th>
                <th class="text-left">Содержание новости</th>
                <th class="text-left">Показовать</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in news" :key="item._id">
                <td>{{ item.title }}</td>
                <td v-html="nl2br(item.text)"></td>
                <td>
                    
                </td>
            </tr>
        </tbody>
        </template>
    </v-simple-table> -->

  <div id="news">
    <v-card v-for="item in news" :key="item._id" class="relative">
      <v-img :src="`/images/news/${item.image}`" height="200px"
        ><v-btn
          class="mx-2"
          fab
          dark
          x-small
          color="black"
          @click="$emit('item', item)"
        >
          <v-icon dark> mdi-pencil </v-icon> </v-btn
        ><v-btn
          class="mx-2 absolute"
          fab
          dark
          x-small
          color="red"
          @click="delete_item(item._id)"
        >
          <v-icon dark> mdi-minus </v-icon>
        </v-btn></v-img
      >

      <v-card-title>
        <h2>{{ item.title || '' }}</h2>
        <h5>{{ formated_date(item.createdAt) }}</h5>
      </v-card-title>

      <v-card-text>
        <div v-html="nl2br(item.text || '')"></div>
      </v-card-text>

      <v-card-actions>
        <v-checkbox
          v-model="item.show_in_statistic"
          @change="toggle_show_news(item)"
          label="Показывать"
        ></v-checkbox>
      </v-card-actions>
      
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "News",
  props: ["news"],
  data: () => ({
    dialog: false,
    myfile: "data:image/png;base64",
    file_name: null,
  }),
  computed: {
    // unbase64MyFile() {
    //   return this.dataURLtoFile(this.myfile, this.file_name);
    // },
  },
  methods: {
    ...mapActions(["update_news", "delete_news"]),
    nl2br(text) {
      return (text + "").replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        "$1" + "<br />" + "$2"
      );
    },
    
    formated_date(date) {
      return new Date(date).toLocaleDateString("ru-RU", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    toggle_show_news(news) {
      console.log(news);
      this.update_news(news);
    },
    delete_item(_id) {
      this.delete_news({ _id });
    },
    
  },
};
</script>

<style scoped>
#news {
  display: grid;
  grid-template-columns: 33% 34% 33%;
  grid-gap: 30px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
  top: 5px;
  right: 0px;
}
</style>